import { render, staticRenderFns } from "./CrudActions.vue?vue&type=template&id=4fde7335&"
import script from "./CrudActions.vue?vue&type=script&lang=js&"
export * from "./CrudActions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports